import React from "react";
import zoomSdk from "@zoom/appssdk";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";

import FeedbackCard from "../common/FeedbackCard";
import WikiCard from "../common/WikiCard";
import LogManager from "../utils/LogManager";

/**
 * Help tab in the in-meeting Aims app
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Help = () => {
  const handleWikiClick = async () => {
    try {
      await zoomSdk.openUrl({
        url: "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS",
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <Column alignmentHorizontal="center" spacing="none">
      <Column height="24px" />
      <Box width="370px">
        <Row spacing="none">
          <Row width="50px" />
          <FeedbackCard />
        </Row>
      </Box>
      <Column height="16px" />
      <Box width="370px">
        <Row spacing="none">
          <Row width="50px" />
          <WikiCard />
        </Row>
      </Box>
    </Column>
  );
};
export default Help;
